import styles from './loader.module.scss';

const Loader = () => {
  return <div className={styles.ldsDualRing}></div>;
};

export default Loader;
